import { render, staticRenderFns } from "./NuevoUsuarioEvt.vue?vue&type=template&id=4f567cdf"
import script from "./NuevoUsuarioEvt.vue?vue&type=script&lang=js"
export * from "./NuevoUsuarioEvt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports